import axios from 'axios'
import qs from 'qs';
import store from '@/store'
import Vue from 'vue';
import {
	Toast
} from 'vant';
Vue.use(Toast);

// 创建axios实例
const service = axios.create({
	baseURL: '',
	timeout: 5000 // timeout
})
// request拦截器
service.interceptors.request.use(
	config => {
		config.method === 'post'
			? config.data = qs.stringify({...config.data})
			: config.params = {...config.params};
		config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
		return config
	},
	error => {
		console.log(error)
		Toast(error);
		return Promise.reject(error)
	}
)

// respone拦截器
service.interceptors.response.use(
	async response => { //成功请求到数据
		// console.log(response)
		const res = response.data;
		if (res.errno != 200) {
			Toast(res.msg || 'Error');
			if (res.errno === 408 || res.errno === 401) {
				// 去登录页
				await store.dispatch('user/resetToken')
				location.reload()
			}
			return Promise.reject(new Error(res.msg || 'Error'))
		} else {
			return res
		}
	},
	error => { //响应错误处理
		console.log(error)
		Toast(error);
		return Promise.reject(error)
	}
)

export default service
